import { ServiceStore } from "@intrasync/stores";
import { RouteType } from "types/RouteType";

const ProductionScheduleWizardRoute: RouteType = {
  name: "ProductionScheduleWizard",
  path: "/workflows/production-schedule",
  layout: "/app",
  group: "Workflows",
  requiresAuth: true,
  requiresPermission: false,
  viewportCard: {
    header: {
      title: "Production Schedule",
      component: () => import("./ProductionScheduleWizardHeader"),
      enableRefreshButton: false,
      enableBackButton: true,
    },
    body: {
      component: () => import("./ProductionScheduleWizard"),
      grayBackground: true,
    },
  },
  beforeEnter: async ({ rootStore }) => {
    try {
      const jobStore = rootStore.jobStore as ServiceStore;
      const billOfMaterialsStore = rootStore.billOfMaterialsStore as ServiceStore;
      const bomItemsStore = rootStore.bomItemsStore as ServiceStore;
      const productsStore = rootStore.productsStore as ServiceStore;
      const castingMapLayoutStore = rootStore.castingMapLayoutStore as ServiceStore;
      const jobScheduleStore = rootStore.jobScheduleStore as ServiceStore;
      const panelStore = rootStore.panelStore as ServiceStore;

      await Promise.all([
        jobStore?.find(),
        billOfMaterialsStore?.find(),
        bomItemsStore?.find(),
        productsStore?.find(),
        castingMapLayoutStore?.find(),
      ]);

      return true;
    } catch (error) {
      console.error("Failed to load data for production schedule:", error);
      return false;
    }
  },
};

export default ProductionScheduleWizardRoute;